import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  Row, Col, Button, Form, Input, Select, message, Tabs, Modal } from 'antd';
import * as debugLib from 'debug';
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import * as Service from '../../core/Service';
import FormUploadFile from "../form/FormUploadFile";
import { Link } from 'react-router-dom';

const debug = debugLib('app:pages/company/webStatusModal');

const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

const DocumentUploadModel = (props) => {
  const { t } = useTranslation()
  const [imageURL, setImageURL] = useState("");
  const [fileinfo, setFileinfo] = useState({});
  const [isActive, setIsActive] = useState(false);
  const [childCategoryOption, setChildCategoryOption] = useState([])
  const [formItemVisible, setFormItemVisible] = useState(false);
  const STATIC_SERVER_URL = useSelector(
    (state) => state.app.config.STATIC_SERVER_URL
  );
  const {
    selectedRecord, categoryList, modalVisible, setModalVisible, handleFormSubmit
  } = props

  const [DocumentForm] = Form.useForm();

  useEffect(() => {
    getParentOption();
    if (selectedRecord) {
      if (selectedRecord.filepath) {
        setImageURL(`${STATIC_SERVER_URL}/${selectedRecord.filepath}`);
      } else {
        setImageURL("");
      }
      if (selectedRecord.user_upload_id === 0) {
        setFormItemVisible(true);
      }
    }
    setIsActive(selectedRecord.is_active)
    DocumentForm.resetFields()
  }, [selectedRecord])


  const uploadOnChange = (info) => {
    const { status, response } = info.file;
    if (status === "done") {
      message.destroy();
      if (response.status > 0) {
        message.success(t("uploaded"));
        let data = {
          filename: info.file.response.filename,
          filepath: info.file.response.filepath,
        };
        let path = `${STATIC_SERVER_URL}/${info.file.response.filepath}`;
        setImageURL(path);
        setFileinfo(data);
        return;
      }
      message.error(t("fail"));
    }
  };

  const getParentOption = async () => {
    let result = await Service.call('get', '/api/item/category/list/child');
    let { data } = result;
    if (result.status !== 1) {
      return message.error(result.errorMessage)
    }
    setChildCategoryOption(data)
  }
  return (
    <Modal
      title={selectedRecord.user_upload_id === 0 ? t('add_new_document') : t('edit_document')}
      visible={modalVisible}
      footer={null}
      onCancel={() => {
        setModalVisible(false)
      }}
    >
      <Form
        form={DocumentForm}
        name="DocumentForm"
        layout="vertical"
        initialValues={selectedRecord}
        onFinish={(formData) => {
          formData.company_id = selectedRecord.company_id
          formData.banner = null;

          if (selectedRecord.filepath) {
            formData.banner = selectedRecord.filepath;
          }

          if (fileinfo.filepath) {
            formData.banner = fileinfo.filepath;
          }

          handleFormSubmit(formData)
          setModalVisible(false);
        }}
      >
        {/* <Form.Item
          label={t('user_id')}
          name="user_id"
        >
          <Input defaultValue={userID} disabled/>
        </Form.Item> */}

        <Form.Item
          label={t('remark')}
          name="remark"
          rules={[{ required: true, message: t('input_required') }]}
        >
          <Input maxLength={50} />
        </Form.Item>

        <Form.Item label={t("image")} name="item_feature_image">
          {_.isEmpty(imageURL) ? (
            <FormUploadFile
              data={{ scope: "public" }}
              onChange={uploadOnChange}
            />
          ) : (
            <Row style={{ alignItems: 'flex-end' }}>
              {!_.includes(imageURL, '.jpeg', '.png') ? (
                <Link onClick={() => window.location.href = imageURL }>{selectedRecord.filepath || `media${_.split(imageURL, '/media')[1]}`}</Link>
              ) : (
                <img
                  alt=""
                  src={imageURL}
                  style={{
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                  }}
                />
              )}
              <Col style={{ marginLeft: '10px' }}>
                {_.includes(imageURL, '.jpeg', '.png') && (
                  <p style={{ marginBottom: '5px' }}>150 X 150</p>
                )}
                <Button
                  type="default"
                  onClick={() => {
                    setImageURL()
                    selectedRecord.filepath = '';
                  }}
                >
                  Remove Current file
                </Button>
              </Col>
            </Row>
          )}
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
          >
            {t('submit')}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default DocumentUploadModel;
